import { ScrollArea } from "@base-ui/react/scroll-area"
import React, { useEffect, useRef } from "react"

import classNames from "classnames"

import { times } from "shared/lib/times"
import { WithClassName } from "shared/types/WithClassName"

import { BreadcrumbItem } from "./BreadcrumbItem"

export interface BreadcrumbWrapperProps extends WithClassName {
  children?: React.ReactNode[]
  loadingItemAmount?: number
  isLoading?: boolean
}

export const BreadcrumbWrapper = React.memo(
  ({
    children,
    isLoading,
    loadingItemAmount = 3,
    className
  }: BreadcrumbWrapperProps) => {
    const viewportRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
      if (viewportRef.current) {
        viewportRef.current.scrollLeft = viewportRef.current.scrollWidth
      }
    }, [])

    if (!isLoading && !children) {
      return null
    }

    return (
      <ScrollArea.Root
        className={classNames(
          "scroll-area",
          "scroll-area--horizontal",
          "shadow-m",
          "breadcrumb-scroll-container",
          className
        )}
        data-testid="breadcrumb"
      >
        <ScrollArea.Viewport
          ref={viewportRef}
          className="scroll-area__viewport"
        >
          <ScrollArea.Content className="scroll-area__content">
            <ol className="breadcrumb">
              {isLoading
                ? times(loadingItemAmount).map(num => (
                    <BreadcrumbItem
                      key={num}
                      isLoading
                      isActive={loadingItemAmount === num}
                    />
                  ))
                : children}
            </ol>
          </ScrollArea.Content>
        </ScrollArea.Viewport>
      </ScrollArea.Root>
    )
  }
)
